import React from "react";
import { Lock, Crown } from "lucide-react";

const PremiumLocked = ({ title, subtitle, onUnlock }) => {
  return (
    <div
      className="rounded-3xl bg-gradient-to-br from-[#FDFBF7] to-[#F5D0D6]/30 border border-[#F5D0D6]/60 p-6 text-center relative overflow-hidden"
      data-testid="premium-locked"
    >
      <div className="w-12 h-12 rounded-full bg-white border border-[#F5D0D6] flex items-center justify-center mx-auto shadow-sm">
        <Lock className="w-5 h-5 text-[#234B38]" strokeWidth={1.5} />
      </div>
      <h3 className="text-lg font-medium text-[#1A2E24] mt-3" style={{ fontFamily: "Outfit, sans-serif" }}>
        {title}
      </h3>
      {subtitle && <p className="text-sm text-[#5C7568] mt-1.5 leading-relaxed">{subtitle}</p>}
      {onUnlock && (
        <button
          onClick={onUnlock}
          data-testid="unlock-premium-btn"
          className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#234B38] hover:bg-[#1A382A] text-white px-6 py-3 text-sm font-medium transition-colors"
        >
          <Crown className="w-4 h-4" strokeWidth={1.75} />
          Unlock Pro
        </button>
      )}
    </div>
  );
};

export default PremiumLocked;
